module.exports = __webpack_public_path__ + "img/afpi.fafb96be.png";